export const TOKEN_KEY = 'token';
export const APPLICATION_ID_KEY = 'application-id';
export const STOREFRONT_ID_KEY = 'storefront-id';
export const PID_KEY = 'pid';
export const SID_KEY = 'sid';
export const UNIQUEID_KEY = 'uniqueId';
export const APP_VERSION_KEY = 'version';
export const AB_COOKIE_KEY = 'abTestingValues';
